<div class="button-list-larger">
    <ng-template #subpanelDetails let-subpanel let-showDisplayTitle="showDisplayTitle" let-isMobile="isMobile" let-isModal="isModal">
        <h4 class="text-blue panel-title fs-5 fs-md-22" [class.button-list-larger-modal-title]="isModal" *ngIf="subpanel.panelTitle">{{ subpanel.panelTitle }}</h4>
        <h4 class="text-blue panel-title fs-5 fs-md-22" [class.button-list-larger-modal-title]="isModal" *ngIf="showDisplayTitle && subpanel.displayTitle">
            {{ subpanel.title }}
        </h4>

        <div class="panel-text text-link" embeddedHTML [innerHTML]="subpanel.bodyText"></div>

        <div *ngIf="subpanel.additionalArticles?.length">
            <div *ngFor="let resource of subpanel.additionalArticles">
                <h4 *ngIf="resource.displayTitle" class="text-blue panel-title fs-5 fs-md-22" [ngClass]="isMobile ? 'my-4' : 'mt-5 mb-4'">
                    {{ resource.title }}
                </h4>
                <div embeddedHTML class="text-link mb-4" [innerHTML]="resource.bodyText"></div>
            </div>
        </div>

        <div *ngIf="subpanel.bullets?.length" class="mt-4">
            <p *ngFor="let bullet of subpanel.bullets" class="my-4">
                {{ bullet }}
            </p>
        </div>

        <div *ngIf="accountsTitle && subpanel.accounts?.length" class="accounts-title">
            {{ accountsTitle }}
        </div>

        <div
            class="account-panel"
            *ngFor="let account of subpanel.accounts || []; let acc = index; first as isFirst"
            [ngClass]="{ 'text-link': !isMobile, first: isFirst, last: acc === (subpanel.accounts?.length || 0) - 1 }"
        >
            <a class="account-heading-link" [class.d-flex]="!isMobile" [class.text-link]="isMobile" [class.fs-18]="isMobile" target="_blank" link [href]="account.Website">
                <span>{{ account.Name }}</span>
            </a>
            <p [class.mt-3]="!isMobile">{{ account.Additional_Posted_Information__c }}</p>
        </div>

        <button
            type="button"
            *ngIf="subpanel.link"
            (click)="subpanel.link.onClick()"
            class="text-link fw-bolder bg-transparent border-0 p-0"
            [innerText]="subpanel.link.title"
        ></button>

        <div
            class="text-center bg-greyish rounded-3 image-wrap"
            [ngClass]="isMobile ? 'pt-4 mt-2' : 'mt-4'"
            *ngIf="subpanel.images?.length > 0 && subpanel.images[0].url !== '0693d000006zZLNAA2'"
        >
            <img class="img-fluid d-print-none" [src]="imageUrl(subpanel.images[0])" [alt]="subpanel.images[0].altText" />
        </div>
    </ng-template>

    <div class="top-container container-xxxl">
        <ul class="nav nav-tabs top-level-nav border-0 mx-n4 d-print-none" [ngClass]="{ hide: tabs?.length === 1 || hideTabs }" role="tablist">
            <li class="nav-item" role="presentation" *ngFor="let tab of tabs; let t = index">
                <button
                    class="nav-link border-0 text-center fs-18 fs-md-4"
                    type="button"
                    role="tab"
                    (click)="onTabClick(t)"
                    (keydown)="onTopTabKeydown($event, t)"
                    [ngClass]="{ active: tabIndex === t }"
                    [attr.id]="'diag-panel-control' + t"
                    [attr.aria-controls]="'diag-panel' + t"
                    [attr.aria-selected]="tabIndex === t ? 'true' : 'false'"
                    [attr.tabindex]="tabIndex === t ? '0' : '-1'"
                >
                    {{ tab.title }}
                </button>
            </li>
        </ul>
    </div>

    <div class="bottom-container">
        <div class="container-xxxl">
            <div class="tab-content main-pills">
                <div
                    class="tab-pane show d-print-block"
                    [ngClass]="{ active: t === tabIndex, show: t === tabIndex }"
                    *ngFor="let tab of tabs; let t = index"
                    [attr.id]="'diag-panel' + t"
                    role="tabpanel"
                    [attr.aria-labelledby]="'diag-panel-control' + t"
                >
                    <!-- desktop view -->
                    <div class="d-none d-lg-block d-print-block">
                        <div class="row">
                            <div class="col-5 px-0 d-print-none">
                                <div class="nav flex-column nav-pills v-pills-tab" role="tablist" aria-orientation="vertical">
                                    <h2 class="text-blue panel-title" *ngIf="tab.sectionHeader" [innerHTML]="tab.sectionHeader"></h2>
                                    <button
                                        class="nav-link fs-18"
                                        type="button"
                                        role="tab"
                                        *ngFor="let pill of tab.items; let st = index"
                                        (click)="onSubTabClick(st)"
                                        (keydown)="onSubTabKeydown($event, t, st, tab.items?.length || 0)"
                                        [ngClass]="{ active: t === tabIndex && st === stIndex }"
                                        [attr.id]="'diag-pill-control' + t + '-' + st"
                                        [attr.aria-selected]="t === tabIndex && st === stIndex ? 'true' : 'false'"
                                        [attr.aria-controls]="'diag-pill' + t + '-' + st"
                                        [attr.tabindex]="t === tabIndex && st === stIndex ? '0' : '-1'"
                                    >
                                        {{ pill.title }}
                                    </button>
                                </div>
                            </div>

                            <div class="col-7 px-0 d-print-block">
                                <div class="tab-content h-100">
                                    <div
                                        class="tab-pane h-100 position-relative d-print-block"
                                        role="tabpanel"
                                        *ngFor="let subpanel of tab.items; let st = index"
                                        [ngClass]="{ active: t === tabIndex && st === stIndex, show: t === tabIndex && st === stIndex }"
                                        [attr.id]="'diag-pill' + t + '-' + st"
                                        [attr.aria-labelledby]="'diag-pill-control' + t + '-' + st"
                                        [attr.aria-hidden]="t === tabIndex && st === stIndex ? 'false' : 'true'"
                                    >
                                        <div class="d-flex flex-row w-100">
                                            <div class="subpanel-content fs-md-18 w-100">
                                                <ng-container
                                                    *ngTemplateOutlet="subpanelDetails; context: { $implicit: subpanel, showDisplayTitle: true, isMobile: false, isModal: false }"
                                                ></ng-container>

                                                <div class="nav flex-column nav-pills w-100">
                                                    <button
                                                        class="nav-link fs-5 d-print-none"
                                                        type="button"
                                                        (click)="toggleSubSub(sst)"
                                                        *ngFor="let subsub of subpanel.items; let sst = index"
                                                        [attr.aria-expanded]="sst === sstIndex ? 'true' : 'false'"
                                                        [attr.aria-controls]="'subsubtab' + t + '-' + st + '-' + sst"
                                                    >
                                                        {{ subsub.title }}
                                                    </button>
                                                    <div
                                                        class="position-absolute panel-overlap bg-lightblue pe-3 collapse overflow-auto d-print-block"
                                                        [ngClass]="{ show: sst === sstIndex }"
                                                        *ngFor="let subsub of subpanel.items; let sst = index"
                                                        [attr.id]="'subsubtab' + t + '-' + st + '-' + sst"
                                                        [attr.aria-hidden]="sst === sstIndex ? 'false' : 'true'"
                                                    >
                                                        <div class="d-flex flex-row w-100 overflow-auto">
                                                            <div class="back-button-container d-print-none">
                                                                <img
                                                                    src="assets/back-arrow.svg"
                                                                    alt="Back"
                                                                    class="fs-18 text-green ps-4 pt-3"
                                                                    type="button"
                                                                    (click)="toggleSubSub(sst)"
                                                                    aria-expanded="false"
                                                                    [attr.aria-controls]="'subsubtab' + t + '-' + st + '-' + sst"
                                                                />
                                                            </div>
                                                            <div>
                                                                <h4 class="text-blue panel-title fs-5 fs-md-22">{{ subsub.title }}</h4>
                                                                <div class="panel-text text-link" embeddedHTML [innerHTML]="subsub.bodyText"></div>
                                                                <div class="my-4 text-center bg-greyish rounded-3 image-wrap" *ngIf="subsub.images?.length > 0">
                                                                    <img class="img-fluid d-print-none" [src]="imageUrl(subsub.images[0])" [alt]="subsub.images[0].altText" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- mobile view -->
                    <div class="d-block d-lg-none d-print-none w-100 h-100 position-relative px-3" *ngIf="tab.type === panelType.normal">
                        <mobile-panel-list
                            [items]="tab.items || []"
                            [sectionHeader]="tab.sectionHeader || ''"
                            [modalClass]="mobileModalClass"
                            contentClass="button-list-larger-mobile-modal-content px-4 pb-4 pt-0"
                        >
                            <ng-template #mobilePanelContent let-subpanel let-isMobile="isMobile">
                                <div class="button-list-larger">
                                    <div class="main-pills">
                                        <ng-container
                                            *ngTemplateOutlet="subpanelDetails; context: { $implicit: subpanel, showDisplayTitle: true, isMobile: isMobile, isModal: true }"
                                        ></ng-container>
                                    </div>
                                </div>
                            </ng-template>

                            <ng-template #mobilePanelChildContent let-subsub>
                                <div class="button-list-larger">
                                    <div class="main-pills">
                                        <h4 class="text-blue panel-title fs-5 fs-md-22">{{ subsub.title }}</h4>
                                        <div class="panel-text text-link" embeddedHTML [innerHTML]="subsub.bodyText"></div>
                                        <div class="mt-4 text-center bg-greyish rounded-3 image-wrap" *ngIf="subsub.images?.length > 0">
                                            <img class="img-fluid d-print-none" [src]="imageUrl(subsub.images[0])" [alt]="subsub.images[0].altText" />
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </mobile-panel-list>
                    </div>

                    <!-- info view -->
                    <div *ngIf="tab.type === panelType.info">
                        <div class="row mt-5">
                            <div class="col-lg-6">
                                <div class="text-center rounded-3">
                                    <img class="img-fluid d-print-none" [src]="imageUrl(tab.img)" [alt]="tab.img.altText" />
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="my-4 my-lg-0 mb-4" *ngFor="let item of tab.items">
                                    <h4 class="text-blue panel-title fs-5 fs-md-22" *ngIf="item.displayTitle">{{ item.title }}</h4>
                                    <p class="mt-3 panel-text text-link fs-md-18" embeddedHTML [innerHTML]="item.bodyText"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
